export const apiConstants = {
  url: "/api/child"
};
